import { render, staticRenderFns } from "./SiloPropertyCarousel.vue?vue&type=template&id=2204e63f"
import script from "./SiloPropertyCarousel.vue?vue&type=script&lang=js"
export * from "./SiloPropertyCarousel.vue?vue&type=script&lang=js"
import style0 from "./SiloPropertyCarousel.vue?vue&type=style&index=0&id=2204e63f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports